import { createContext } from 'react'


const MediaContext = createContext<MediaProps & Device>(null)


export default MediaContext
